import { Component, Input } from '@angular/core';
import { FormBase } from '../../../_classes/form-base.class';
import ITreatmentCategory from '../../../_interfaces/ITreatmentCategory';
import { Observable } from 'rxjs';
import { MessageService } from 'primeng/api';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { SessionService } from '../../../_services/session/session.service';
import { ValidatorService } from '../../../_services/validators/validator.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TreatmentsCategoriesService } from '../../../_services/treatments/treatments-categories.service';
import { EResources } from '../../../_resources/EResources';
import { AdminFormActionsComponent } from '../../admin-ui/admin-form-actions/admin-form-actions.component';

@Component({
  selector: 'app-form-category-treatments',
  imports: [
    TranslatePipe,

    FormsModule,
    CommonModule,
    ButtonModule,
    InputTextModule,
    AdminFormActionsComponent,
  ],
  templateUrl: './form-category-treatments.component.html',
  styleUrl: './form-category-treatments.component.scss',
})
export class FormCategoryTreatmentsComponent extends FormBase<ITreatmentCategory> {
  @Input() showIntro = true;
  public submitting = false;

  constructor(
    public treatmentsCategoriesService: TreatmentsCategoriesService,
    public messageService: MessageService,
    public validateService: ValidatorService,
    public translate: TranslateService,
    public session: SessionService
  ) {
    super(session, messageService, translate);
  }

  clear(): void {
    this.payload = {
      name: undefined,
    };
  }
  generatePayload(): ITreatmentCategory {
    return {
      name: this.payload.name,
    };
  }
  getResourceName(): string {
    return EResources.PRODUCTS_CATEGORIES;
  }
  updateFn(payload: ITreatmentCategory): Observable<any> {
    return this.treatmentsCategoriesService.update(
      this.customers_id,
      this.id,
      payload
    );
  }
  createFn(payload: ITreatmentCategory): Observable<any> {
    return this.treatmentsCategoriesService.create(this.customers_id, payload);
  }
  properties(): string[] {
    return ['name'];
  }
  validate(): Promise<void> {
    return this.validateService.productCategory(this.payload);
  }

  override async execute(): Promise<void> {
    this.submitting = true;
    try {
      await super.execute();
    } finally {
      this.submitting = false;
    }
  }

  get formTitleKey(): string {
    return this.mode === 'edit'
      ? 'ADMIN.TREATMENTS.ALL.CATEGORIES'
      : 'ADMIN.TREATMENTS.ADD.CATEGORIES';
  }

  get formDescriptionKey(): string {
    return 'ADMIN.IA.TREATMENTS.DESCRIPTION';
  }
}
